import { render, staticRenderFns } from "./FbdToWordPage.vue?vue&type=template&id=237ce867"
import script from "./FbdToWordPage.vue?vue&type=script&lang=ts"
export * from "./FbdToWordPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports